<template>
  <div style="background-color:white">
   
      <!-- KITS -->
         
        <v-layout row wrap >

          <v-flex xs12 sm12 md12 lg12>
              <v-img src="titulokits.png" >         
                <div align="center">
                  <p class="titulos" style="padding-top:25px">{{title1}}</p>
                </div>                       
              </v-img>
          </v-flex>

          <v-flex xs12 sm4 md4 lg4 v-for="kit in kits" :key="kit.title">       
            <div class="container" align="center">
              <v-img  :src="kit.image" alt="kit de valores" width="70%"></v-img> 
              <div class="overlay">
                <div class="text" :class="`description ${kit.id}`">{{kit.description}}</div>
              </div>   
            </div>  
            <p  :class="`producto ${kit.id}`">{{kit.title}}</p>

            <v-layout justify-center> 
              <v-flex xs7 sm6 md6 lg6>     
                <a :href="kit.url" target="_blank" style="text-decoration:none">
                  <!--<router-link class="menu" :to="kit.url" >-->
                  <v-btn color="info" class="button" round>Más información</v-btn> 
                  <!--</router-link>-->
                </a>
              </v-flex> 
             </v-layout>           
          </v-flex>

          <v-layout justify-center>
          <v-flex xs12 sm9 md9 lg9 justify-center> 
            <br><br>
            <v-img src="textokits.png" >
              <v-layout justify-center>
                 <v-flex xs11 sm10 md10 lg10 >
                    <div align="center">
                      <p style="padding-top:35px">
                        <span class="descripcionA"  >{{descriptionkit1}}</span><br>
                        <span class="descripcionB">{{descriptionkit2}}</span>
                      </p>
                      <p style="padding-top:35px">
                        <span class="descripcionA">{{descriptionkit3}}</span>
                        <span class="descripcionB">{{descriptionkit4}}</span>
                      </p>
                      <p style="padding-top:35px">
                        <span class="descripcionA" >{{descriptionkit5}}</span>           
                      </p>
                    </div>
                  </v-flex>
                </v-layout>
              </v-img>
            </v-flex> 
            </v-layout>  
          </v-layout>
    
      <!--LIBROS-->


      <v-layout row wrap justify-center>

        <v-flex xs12 sm12 md12 lg12>
          <v-img src="titulolibros.png">  
            <div align="center">
              <p class="titulos" style="color:white;padding-top:25px">{{title2}}</p>
            </div>
          </v-img>
        </v-flex>

        <v-flex xs12 sm4 md4 lg4 v-for="libro in libros" :key="libro.title" background-color="white">          
          <div class="container" align="center">
            <v-img  :src="libro.image" alt="kit de valores" width="70%"></v-img> 
            <div class="overlay">
              <div class="text" :class="`description ${libro.id}`">{{libro.description}}</div>
            </div>   
          </div>  
          <p  :class="`producto ${libro.id}`">{{libro.title}}</p>
              
          <v-layout justify-center> 
            <v-flex xs7 sm6 md6 lg6>     
              <a :href="libro.url" target="_blank" style="text-decoration:none">
                <!--<router-link class="menu" :to="libro.url" >-->
                <v-btn color="info" class="button" round>Más información</v-btn> 
                <!--</router-link>-->
             </a>
            </v-flex>                
          </v-layout>                 
        </v-flex>
        <v-flex xs12 sm9 md9 lg9 justify-center>
          <br><br>
          <v-img src="textolibros.png">
            <v-layout justify-center>
              <v-flex xs11 sm10 md10 lg10 >
                <div align="center">
                  <p class="descripcionA" style="padding-top:35px">{{descriptionlibro1}}</p>
                  <p class="descripcionB" style="text-align:left">{{descriptionlibro2}}</p><br>
                  <p class="descripcionB" style="text-align:left">{{descriptionlibro3}}</p><br>
                  <p class="descripcionB" style="text-align:left">{{descriptionlibro4}}</p>
                </div>
              </v-flex>
            </v-layout>
          </v-img>
        </v-flex>         
       </v-layout>

  </div>
</template>


<script>
//import VueGallerySlideshow from 'vue-gallery-slideshow'
//import VueGallery from 'vue-gallery';

  export default {
  components:{
  },  
    data(){
    let language=localStorage.getItem('language');
    //echo (language);
    
      if (language=='es-XL' || language=='es' || language=='es-ES') 
      {
        return{   
          /*Textos KITS*/  
            title1:"Juegos didácticos",
            kits:[ 
            {id:"kit1",title:"Hábitos de higiene",image:"KitLalabum1k.png",description:"Diseñado para reforzar las buenas conductas y actitudes hacia el cuidado personal. Es ideal para niños entre 2 y 4 años. Incluye acceso a la app Mundo Lalabum",url:"#/producto1"},
            {id:"kit2",title:"Deberes en casa",image:"KitLalabum2k.png",description:"Diseñado para reforzar las buenas conductas y actitudes hacia los deberes en casa. Es ideal para niños entre 3 y 5 años. Incluye acceso a la app Mundo Lalabum",url:"#/producto2"},
            {id:"kit3",title:"Alimentación sana",image:"KitLalabum3k.png",description:"Diseñado para reforzar las buenas conductas y actitudes hacia una alimentación sana. Es ideal para niños entre 5 y 7 años. Incluye acceso a la app Mundo Lalabum",url:"#/producto3"},      
            {id:"kit1",title:"Playera coloreable",image:"playera-coloreable.jpg",description:"¡Colerean, se lavan y vuelven a pintar las veces que quieran! Incluye plumones y la suscripción a la app educativa Lalabum “Lalabum” Tallas: 2, 4  y 6 años.",url:"#/producto7"},
             ],
             descriptionkit1:"El kit incluye un set de 5 actividades educativas:",
             descriptionkit2:"-Lotería -Rompecabezas -Memorama -Títeres -Flashcards ",
             descriptionkit3:"Además una suscripción anual a la app educativa Mundo Lalabum, que ofrece para tus niños",
             descriptionkit4:": Más de 240 juegos -Cuentos -Coloreables -Canciones -Videos",
             descriptionkit5:"¡Kit Lalabum ayuda a practicar los valores de forma divertida en inglés y español!",
          /* Textos LIBROS*/
            title2:"Programa educativo para preescolar",
            libros:[
            {id:"kit1",title:"Valores en acción 1",image:"LibroLalabum1k.png",description:"Desarrollo de las rutinas, hábitos de higiene, autoconcepto y convivencia sana para niños de 2 a 4 años. Incluye acceso a plataforma para descargar material y a la app Mundo Lalabum",url:"#/producto4"},
            {id:"kit2",title:"Valores en acción 2",image:"LibroLalabum2k.png",description:"Desarrollo de autonomía, expresión de las emociones, respeto a la autoridad, modales y disciplina para niños de 4 a 5 años. Incluye acceso a plataforma para descargar material y a la app Mundo Lalabum",url:"#/producto5"},
            {id:"kit3",title:"Valores en acción 3",image:"LibroLalabum3k.png",description:"Desarrollo de habilidades para comunicarse y convivir sanamente, el cuidado del medio ambiente para niños de 5 a 6 años. Incluye acceso a plataforma para descargar material y a la app Mundo Lalabum",url:"#/producto6"},
            ],
            descriptionlibro1:"El programa Lalabum para preescolar se utiliza como libro escolar o para escuela en casa. Este programa Incluye:",
            descriptionlibro2:"-Libro de actividades Lalabum Valores en acción con contenidos recortables y juegos para utilizar en cada clase.",
            descriptionlibro3:"-El acceso a la plataforma de maestros o padres de familia para descargar los contenidos de clase como: planeaciones, canciones,cuentos y videos.",
            descriptionlibro4:"-Suscripción anual a la app educativa Mundo Lalabum, que ofrece para tus niños: Más de 240 Actividades, Juegos, Cuentos, Coloreables, Canciones y Videos."
        }
      } else {
        return{      
         /*Textos KITS*/  
           title1:"Juegos didácticos",
            kits:[ 
            {id:"kit1",title:"Hábitos de higiene",image:"KitLalabum1k.png",description:"Diseñado para reforzar las buenas conductas y actitudes hacia el cuidado personal. Es ideal para niños entre 2 y 4 años. Incluye acceso a la app Mundo Lalabum",url:"#/producto1"},
            {id:"kit2",title:"Deberes en casa",image:"KitLalabum2k.png",description:"Diseñado para reforzar las buenas conductas y actitudes hacia los deberes en casa. Es ideal para niños entre 3 y 5 años. Incluye acceso a la app Mundo Lalabum",url:"#/producto2"},
            {id:"kit3",title:"Alimentación sana",image:"KitLalabum3k.png",description:"Diseñado para reforzar las buenas conductas y actitudes hacia una alimentación sana. Es ideal para niños entre 5 y 7 años. Incluye acceso a la app Mundo Lalabum",url:"#/producto3"},
            {id:"kit1",title:"Playera coloreable",image:"playera-coloreable.jpg"},      
             ],
             descriptionkit1:"El kit incluye un set de 5 actividades educativas:",
             descriptionkit2:"-Lotería -Rompecabezas -Memorama -Títeres -Flashcards ",
             descriptionkit3:"Además una suscripción anual a la app educativa Mundo Lalabum, que ofrece para tus niños",
             descriptionkit4:": Más de 240 juegos -Cuentos -Coloreables -Canciones -Videos",
             descriptionkit5:"¡Kit Lalabum ayuda a practicar los valores de forma divertida en inglés y español!",
          /* Textos LIBROS*/
            title2:"Programa educativo para preescolar",
            libros:[
            {id:"kit1",title:"Valores en acción 1",image:"LibroLalabum1k.png",description:"Desarrollo de las rutinas, hábitos de higiene, autoconcepto y convivencia sana para niños de 2 a 4 años. Incluye acceso a plataforma para descargar material y a la app Mundo Lalabum",url:"#/producto4"},
            {id:"kit2",title:"Valores en acción 2",image:"LibroLalabum2k.png",description:"Desarrollo de autonomía, expresión de las emociones, respeto a la autoridad, modales y disciplina para niños de 4 a 5 años. Incluye acceso a plataforma para descargar material y a la app Mundo Lalabum",url:"#/producto5"},
            {id:"kit3",title:"Valores en acción 3",image:"LibroLalabum3k.png",description:"Desarrollo de habilidades para comunicarse y convivir sanamente, el cuidado del medio ambiente para niños de 5 a 6 años. Incluye acceso a plataforma para descargar material y a la app Mundo Lalabum",url:"#/producto6"},
            ],
            descriptionlibro1:"El programa Lalabum para preescolar se utiliza como libro escolar o para escuela en casa. Este programa Incluye:",
            descriptionlibro2:"-Libro de actividades Lalabum Valores en acción con contenidos recortables y juegos para utilizar en cada clase.",
            descriptionlibro3:"-El acceso a la plataforma de maestros o padres de familia para descargar los contenidos de clase como: planeaciones, canciones,cuentos y videos.",
            descriptionlibro4:"-Suscripción anual a la app educativa Mundo Lalabum, que ofrece para tus niños: Más de 240 Actividades, Juegos, Cuentos, Coloreables, Canciones y Videos."
        }
      }      
    },
    methods: {
       onClick(i) {
      this.index = i;
    }
    }
    
  }

</script>
<style>
/* Fuentes */
@import url('https://fonts.googleapis.com/css?family=Fredoka+One|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i');


/* Titulos */
.titulos{
  text-align: center;
  font-weight: 500;
  font-family: Fredoka one;
  color:white;
}

/* Description Container */

.container {
  position: relative;
  width: 100%;
}

.container:hover .overlay {
  opacity: .9;
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: .5s ease;
  background-color:#f5f5f5;
}

.text {
  font-family: poppins;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}

.producto{
  text-align: center;
  font-weight: 500;
  font-family: Fredoka one;
}

/*Titulo Producto*/
.description.kit1,.producto.kit1{
    color:#792364;
}
.description.kit2,.producto.kit2{
    color:#50b05e;
}

.description.kit3,.producto.kit3{
    color:#338ec9;
}

/* Boton */
.button{
  text-transform:capitalize; 
  font-family:Fredoka one; 
}


.descripcionA{
  font-family: Fredoka one;
  font-weight: 500;
  color:white;

}

.descripcionB{
  font-family: poppins;
  font-weight: 400;
  color:white;
}



@media (min-width: 1200px){

  .titulos{
      font-size:3vw!important;
    }

    .text{ 
        font-size:1.5vw;   
    }
     .descripcionA { 
        font-size:1.9vw;   
    }

    .descripcionB{
      font-size:1.7vw;
    }
    .producto{
         font-size:2.3vw;
    }

    .button{
      font-size:1.6vw;
    }

    
}

@media (min-width: 300px) and (max-width: 750px){

    .titulos{
      font-size:8.2vw!important;
    }

    .text{
        font-size: 4.7vw;
    }
    .producto{
        font-size: 7.6vw;
    }

    .button{
      font-size:5.5vw
    }

    .descripcionA { 
        font-size:6.9vw;   
    }

    .descripcionB{
      font-size:5.7vw;
    }
}






</style>
